import { useEffect, useMemo } from 'react';
import { useAppSelector } from '../../../hooks';
import { selectGates } from '../../../reducers/Portal';
import { removeThemeSetting } from 'foundations-theming/utils/themeSwitcher';
export const useSyncTrellisTheme = () => {
  const gates = useAppSelector(selectGates);
  const isUngated = useMemo(() => {
    return gates && gates.includes('trellis:primary');
  }, [gates]);
  useEffect(() => {
    // If the user is gated, turn off the trellis theme
    if (!isUngated) {
      removeThemeSetting();
    }
  }, [isUngated]);
};